import axios from 'axios'
import { GetHeaderWithToken } from 'resources/Utils';

const getResources = async () => {
    const url = `${window._env_.COMMUNITY_API_URL}/implementation-resources`;
    const error = (error) => { // Use this function to handle error from fetch and returning to the component the value you need
        console.error(`Error fetching resources: ${error}`)
        return {
            resource: [
                {
                    description: "Error fetching resources"
                }
            ]
        }
    }
    return axios.get(url, GetHeaderWithToken()).then(
        (response) => {
            if (response?.data?.[0]) {
                console.log(response.data[0])
                return response.data[0]
            }
            return error()
        }, error
    )
}

export default {
    getResources,
}
